import { defineCustomElements } from '@uefadigital/panenka/dist/loader';
import { createRoot } from 'react-dom/client';

import App from './components/app';

import { publicPath } from 'signals/publicPath';

import './style/index.css';

declare global {
  interface Window {
    definePanenka: boolean;
  }
}

if (window.definePanenka) {
  defineCustomElements();
}

const root = document.getElementById('preact_root');
publicPath.value = root?.dataset.customPublicPath ?? import.meta.env.VITE_PUBLIC_PATH ?? '/';

if (root) {
  createRoot(root).render(<App />);
}
